import Button from './form-button';
import StepTitle from './step-title';
import Footer from './footer';
import Header from './header';
import Bar from './bar';
import StepComponents from './step-components'
import Modal from "@/components/modal"


export default  {
    Button,
    StepTitle,
    Footer,
    Header,
    Bar,
    StepComponents,
    Modal
}


// WEBPACK FOOTER //
// ./src/components/index.js